export default __webpack_public_path__ + "static/media/Settings.57b92a5d.svg";